import React from "react";
import Chart from "react-apexcharts";

const STATUS_CONFIG = {
  Cancelled: "#EF4444",
  Declined: "#B91C1C",
  Completed: "#22C55E",
  Pending: "#F59E0B",
  Headed: "#6366F1",
  Reached: "#0EA5E9",
  Started: "#8B5CF6",
  Scanned: "#14B8A6",
  Confirmed: "#10B981",
};

const StatusBreakdownChart = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <p className="text-gray-400">No status data available</p>;
  }

  const categories = rows.map((r) => r.label);

  const statuses = Object.keys(STATUS_CONFIG).filter((status) =>
    rows.some((r) => r.statuses?.[status])
  );

  const series = statuses.map((status) => ({
    name: status,
    data: rows.map((r) => r.statuses?.[status] || 0),
  }));

  const options = {
    chart: { stacked: true, id: "status-breakdown" },
    xaxis: {
      categories,
      labels: { style: { colors: "#FFFFFF" } },
    },
    yaxis: {
      labels: { style: { colors: "#FFFFFF" } },
    },
    colors: statuses.map((s) => STATUS_CONFIG[s]),
    legend: {
      position: "bottom",
      labels: { colors: "#FFFFFF" },
    },
    tooltip: {
      y: {
        formatter: (val) => val.toString(),
      },
    },
  };

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      width="100%"
      height={400}
    />
  );
};

export default StatusBreakdownChart;
